import React, { useEffect, useState } from "react";

const Eligibility = (props) => {
  const isEditMode = props?.urlparams?.params?.bankId?.length > 0;
  const [fields, setFields] = useState([
    {
      name: "minAge",
      label: "Minimum Age",
      type: "number",
      required: true,
    },
    {
      name: "maxAge",
      label: "Maximum Age",
      type: "number",
      required: true,
    },
    {
      name: "minSalary",
      label: "Minimum Salary",
      type: "number",
      required: true,
    },
    {
      name: "employmentType",
      label: "Employment Type",
      type: "select",
      options: _enum.BANKWISE_EMPLOYEE_TYPE,
      required: true,
    },
    {
      name: "creditScore",
      label: "Credit Score",
      type: "number",
      required: true,
    },
  ]);

  const handleSubmit = (e, data) => {
    let payload = {
      ...data,
      creditScore: Number(data?.creditScore),
      minAge: Number(data?.minAge),
      maxAge: Number(data?.maxAge),
      minSalary: Number(data?.minSalary),
      employmentType: data?.employmentType?.toUpperCase(),
    };
    console.log(payload, props.selectedBank?.bankId);

    let bankId;
    if (isEditMode) {
      bankId = props?.urlparams?.params?.bankId;
    } else {
      bankId = props.selectedBank?.bankId;
    }
    props.apis
      .apiUpdateBankOffer(payload, {
        bankId: bankId,
      })
      .then((res) => {
        if (res) {
          props.changeTab(e, "docsrequired");
        }
      });
  };
  const updateFields = (fields, data) => {
    let result = fields?.map((field) => {
      console.log({ field });
      if (field.type === "file") {
        console.log({ data, field });
        field.defaultValue = data[field.name];
        field.value = data[field.name];
        // field.disabled = true;
        return {
          ...field,
        };
      } else {
        return {
          ...field,
          defaultValue: data[field?.name],
          // disabled: true,
        };
      }
    });
    return result;
  };

  useEffect(() => {
    if (isEditMode) {
      let payload = {
        bankId: props?.urlparams?.params?.bankId,
      };
      props.apis.apiGetBankOfferById(payload).then((res) => {
        if (res) {
          let updatedFields = updateFields(fields, res);
          setFields([...updatedFields]);
        }
      });
    }
  }, []);
  return (
    <>
      <AppForm className="container" onSubmit={handleSubmit}>
        {fields?.map((field, i) => {
          return (
            <div
              className={`col-12 col-md-${field?.customcolspan || 4}`}
              key={i}
            >
              <AppInput {...field}></AppInput>
            </div>
          );
        })}
        <div className="nav_container text-end mt-4">
          <button
            type="button"
            className="formdata-cancel-btn btn"
            onClick={(...args) => props.changeTab(...args, "features")}
          >
            Cancel
          </button>
          <button type="submit" className="btn btn-primary ms-3">
            {isEditMode ? "Update" : "Submit"}
          </button>
        </div>
      </AppForm>
    </>
  );
};

export default constore(Eligibility);
